import script from "./template7.vue?vue&type=script&setup=true&lang=js"
export * from "./template7.vue?vue&type=script&setup=true&lang=js"

import "./template7.vue?vue&type=style&index=0&id=02e4366a&lang=less"

const __exports__ = script;

export default __exports__